import { Card, Skeleton, Tabs } from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import ChartComponent from "./Chart";

const { TabPane } = Tabs;

const genderColumn = [
    {
        title: "Gender",
        dataIndex: "gender",
        dataKey: "gender",
    },
    {
        title: "Counts",
        dataIndex: "count",
        dataKey: "count",
    },
    {
        title: "Excellent Reviews",
        dataIndex: "excellent_reviews",
        dataKey: "excellent_reviews",
    },
    {
        title: "Good Reviews",
        dataIndex: "good_reviews",
        dataKey: "good_reviews",
    },
    {
        title: "Bad Reviews",
        dataIndex: "poor_reviews",
        dataKey: "poor_reviews",
    },
];

const ageColumn = [
    {
        title: "Age Group",
        dataIndex: "age_group",
        dataKey: "age_group",
    },
    ...[...genderColumn],
];

const stateColumn = [
    {
        title: "State",
        dataIndex: "state",
        dataKey: "state",
    },
    ...[...genderColumn],
];

function DemoGraphic() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedHotels } = useContext(SettingContext);
    const hotel_ids = selectedHotels;

    const [selectedTab, setSelectedTab] = useState("gender");

    const [genderFormData, setGenderFormData] = useState({
        staff_id,
        hotel_ids,
        all_selected: hotel_ids.length == 0,
        data_for: "gender",
    });

    const [genderData, setGenderData] = useState([]);

    const [ageFormData, setAgeFormData] = useState({
        staff_id,
        hotel_ids,
        all_selected: hotel_ids.length == 0,
        data_for: "age_group",
    });

    const [ageData, setAgeData] = useState([]);

    const [stateFormData, setStateFormData] = useState({
        staff_id,
        hotel_ids,
        all_selected: hotel_ids.length == 0,
        data_for: "states",
    });

    const [stateData, setStateData] = useState([]);

    const {
        status: genderDataStatus,
        data: genderRes,
        refetch: getGenderData,
    } = useQuery(
        "gender-analytics",
        async () => {
            return await HTTP(
                "/analytics/getDemographicTableData",
                genderFormData,
            );
        },
        { enabled: false },
    );

    const {
        status: ageDataStatus,
        data: ageRes,
        refetch: getAgeData,
    } = useQuery(
        "age-analytics",
        async () => {
            return await HTTP(
                "/analytics/getDemographicTableData",
                ageFormData,
            );
        },
        { enabled: false },
    );

    const {
        status: stateDataStatus,
        data: stateRes,
        refetch: getStateData,
    } = useQuery(
        "state-analytics",
        async () => {
            return await HTTP(
                "/analytics/getDemographicTableData",
                stateFormData,
            );
        },
        { enabled: false },
    );

    useEffect(() => {
        getGenderData();
    }, []);

    useEffect(() => {
        const hotel_ids = selectedHotels;
        if (selectedTab == "gender") {
            setGenderFormData({
                ...genderFormData,
                page: 0,
                hotel_ids,
                all_selected: hotel_ids.length == 0,
            });
        } else if (selectedTab == "age") {
            setAgeFormData({
                ...ageFormData,
                page: 0,
                hotel_ids,
                all_selected: hotel_ids.length == 0,
            });
        } else {
            setStateFormData({
                ...stateFormData,
                page: 0,
                hotel_ids,
                all_selected: hotel_ids.length == 0,
            });
        }
    }, [selectedHotels]);

    useEffect(() => {
        getAgeData();
    }, [ageFormData]);

    useEffect(() => {
        getStateData();
    }, [stateFormData]);

    useEffect(() => {
        getGenderData();
    }, [genderFormData]);

    useEffect(() => {
        if (genderDataStatus === "success") {
            setGenderData(genderRes.data);
        }
    }, [genderDataStatus, genderRes]);

    useEffect(() => {
        if (ageDataStatus === "success") {
            setAgeData(ageRes.data);
        }
    }, [ageDataStatus, ageRes]);

    useEffect(() => {
        if (stateDataStatus === "success") {
            setStateData(stateRes.data);
        }
    }, [stateDataStatus, stateRes]);

    function changeView(key) {
        const hotel_ids = selectedHotels;
        if (key == "gender") {
            setGenderFormData({
                ...genderFormData,
                hotel_ids,
                all_selected: hotel_ids.length == 0,
            });
        } else if (key == "age") {
            setAgeFormData({
                ...ageFormData,
                hotel_ids,
                all_selected: hotel_ids.length == 0,
            });
        } else {
            setStateFormData({
                ...stateFormData,
                hotel_ids,
                all_selected: hotel_ids.length == 0,
            });
        }
        setSelectedTab(key);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <Card>
                <Tabs type="card" onChange={changeView}>
                    <TabPane tab="Gender" key="gender">
                        {genderDataStatus != "loading" &&
                        genderDataStatus !== "idle" ? (
                            <CustomTable
                                columns={genderColumn}
                                tableData={genderData}
                                rowKey="id"
                                isScroll
                            />
                        ) : (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 10 }}
                            />
                        )}
                    </TabPane>
                    <TabPane tab="Age" key="age">
                        {ageDataStatus !== "loading" &&
                        ageDataStatus !== "idle" ? (
                            <CustomTable
                                columns={ageColumn}
                                tableData={ageData}
                                rowKey="id"
                                isScroll
                            />
                        ) : (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 10 }}
                            />
                        )}
                    </TabPane>
                    <TabPane tab="State" key="state">
                        {stateDataStatus !== "loading" &&
                        stateDataStatus !== "idle" ? (
                            <CustomTable
                                columns={stateColumn}
                                tableData={stateData}
                                rowKey="id"
                                isScroll
                            />
                        ) : (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 10 }}
                            />
                        )}
                    </TabPane>
                    <TabPane tab="Chart View" key="chart">
                        <ChartComponent />
                    </TabPane>
                </Tabs>
            </Card>
        </Card>
    );
}

export { DemoGraphic };
